import { render, staticRenderFns } from "./applications.page.vue?vue&type=template&id=2427da9e&scoped=true&"
import script from "./applications.page.vue?vue&type=script&lang=js&"
export * from "./applications.page.vue?vue&type=script&lang=js&"
import style0 from "./applications.page.vue?vue&type=style&index=0&id=2427da9e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2427da9e",
  null
  
)

export default component.exports